var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"layout-vertical",class:{ 'is-loading': _vm.isLoading },style:(`--background-image: url(${_vm.backgroundUrl});`)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }